import { Component, OnInit } from '@angular/core';
import { ConfirmationPage } from '../../../shared/types/strings.type';
import { AppSettings } from '../../../shared/PRE-LOAD/app-settings';
import { environment } from '../../../../environments/environment';
import { ReservationService } from '../../../shared/services/reservation/reservation.service';
import { UserSelectionsService } from '../../../shared/services/user-selections/user-selections.service';
import { Utilities } from '../../../shared/utilities/utilities';
import { UserAddress, } from '../../../shared/types/user-details.type';
import { Product } from '../../../shared/types/product.type';
import { CookieService } from 'ngx-cookie-service';
import { HttpParams } from '@angular/common/http';

@Component({
    selector: 'rttd-booking-confirmation',
    templateUrl: './booking-confirmation.component.html',
    styleUrls: [
        require('./booking-confirmation.component.scss').default.toString()
    ]
})
export class BookingConfirmationComponent implements OnInit {
    content: ConfirmationPage;
    isOffsite: boolean;
    pickupLocation: UserAddress;
    reservationId: string;
    product: Product;
    brand = environment.brand.toUpperCase();

    constructor(
        public appSettings: AppSettings,
        private reservationService: ReservationService,
        private userSelectionService: UserSelectionsService,
        private utilities: Utilities,
        private cookieService: CookieService
    ) {
    }

    ngOnInit() {

        this.redirectToThankyouPage();

    }


    redirectToThankyouPage() {

        this.isOffsite = this.userSelectionService.get('startLocation') === this.utilities.startLocationAsString('off');
        this.pickupLocation = this.userSelectionService.get('pickupLocation');
        this.reservationId = this.reservationService.reservationId;
        this.product = this.userSelectionService.get('product');

        var params = new HttpParams()
            .set('appointment', this.convertDate(this.userSelectionService.get('startTime')).toISOString())
            .set('appointmentType', this.isOffsite ? 'offsite' : 'at-retailer')
            .set('modelImage', this.product.image)
            .set('combinedModelName', this.product.combinedModelName)
            .set('modelTreeRef', this.product.modelTreeRef)
            .set('bookingId', this.reservationId);


        const fullURL = `${this.appSettings.retailerRttdThankyouPageUrl}?${params.toString()}`;

        this.cookieService.set( 'rttd-cookie', JSON.stringify(this.pickupLocation) ,{ path : "/"} );
        this.utilities.redirectToUrl(fullURL);
    }

    private convertDate(date: Date) {

      //  the server expects dates in UTC, but the client has the date in local timezone, this make the dates the same and ignores the timezone

        var offset = date.getTimezoneOffset();

        if (offset != null && offset != 0) {

            return new Date(date.getTime() - date.getTimezoneOffset() * 60000);
        }
        return date;

    }


}
